import axios from 'axios'
import axiosRetry from 'axios-retry'
import { ResizeObserver as Polyfill } from '@juggle/resize-observer'

/**
 * Browser-only global setup; a no-op on the SSR server. Kept in a module
 * (rather than inline in resources/js/app.js) so its sourcemap survives the
 * @inertiajs/vite entry transform, which rewrites the entry without emitting
 * a map and would otherwise leave this boot code unmapped in Bugsnag.
 */
export function configureBrowserGlobals(): void {
    if (typeof window === 'undefined') {
        return
    }

    /**
     * We'll load the axios HTTP library which allows us to easily issue requests
     * to our Laravel back-end. This library automatically handles sending the
     * CSRF token as a header based on the value of the "XSRF" token cookie.
     */
    window.axios = axios
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    axiosRetry(axios, { retries: 3 })

    window.ResizeObserver = window.ResizeObserver || (Polyfill as unknown as typeof ResizeObserver)
}
